"use client";
import LocationSelector from "../LocationSelector/locationSelector";

/**
 * Mobile location trigger pill — reuses the exact desktop location pill design.
 */
export default function MobileLocationTrigger({ config }) {
  return <LocationSelector config={config} hideLabel />;
}

